import { combineReducers } from 'redux';

import domain from './domain/domainReducer';
import record from './record/recordReducer';
import reverse from './reverse/reverseReducer';
import zone from './zone/zoneReducer';

export default combineReducers({
	domain,
	record,
	reverse,
	zone,
});
